var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3711 14.3329H39.6961",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 52.2495H39.35",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6748 47.6424H27.4495C27.144 47.6424 26.8965 47.3913 26.8965 47.0805V37.1991C26.8965 36.8882 27.144 36.6357 27.4495 36.6357H30.6748C30.9817 36.6357 31.2289 36.8882 31.2289 37.1991V47.0805C31.2289 47.3913 30.9817 47.6424 30.6748 47.6424Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.69449C1 3.10206 3.06861 1 5.61946 1H44.3806C46.9314 1 49 3.10206 49 5.69449V27.943L48.9285 57.1324C48.5442 59.3304 46.654 61 44.3806 61H5.61946C3.06861 61 1 58.8979 1 56.3055V5.69449Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3027 22.6657H20.1448V14.3327H10.3027V22.6657Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5512 47.6425H19.3259C19.02 47.6425 18.7715 47.3913 18.7715 47.0805V33.8969C18.7715 33.5864 19.02 33.3349 19.3259 33.3349H22.5512C22.8567 33.3349 23.1042 33.5864 23.1042 33.8969V47.0805C23.1042 47.3913 22.8567 47.6425 22.5512 47.6425Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 1V6.83284H31.6615V1",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3711 18.5H39.6961",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3711 22.6657H33.9561",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.797 47.6425H35.5717C35.2662 47.6425 35.0176 47.3913 35.0176 47.0805V30.0451C35.0176 29.7347 35.2662 29.4821 35.5717 29.4821H38.797C39.1025 29.4821 39.35 29.7347 39.35 30.0451V47.0805C39.35 47.3913 39.1025 47.6425 38.797 47.6425Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4267 47.6424H11.2014C10.8956 47.6424 10.6484 47.3913 10.6484 47.0805V41.0504C10.6484 40.74 10.8956 40.4888 11.2014 40.4888H14.4267C14.7333 40.4888 14.9808 40.74 14.9808 41.0504V47.0805C14.9808 47.3913 14.7333 47.6424 14.4267 47.6424Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/studentIcon.d2c31a29997e3bb0ba5dc37d0dc42446.svg";
export { ForwardRef as ReactComponent };